<template>
  <div>
    <!-- 查询 -->
    <el-row :gutter="24" class="search-row" type="flex" justify="space-between">
      <el-col :span="17">
        <search-filter :search-filters="queryFields" :change-handel-function="onChangeSearchField" />
      </el-col>
      <el-col :span="7" style="text-align: right">
        <el-button
          class="tips-btn"
          size="small"
          :disabled="forms.settleStatus != 0 || (forms.settleStatus == 0 && total == 0)"
          @click="toSettlementAll()"
          >全部结算<span style="font-size: 14px" v-if="forms.settleStatus == 0">({{ total }})</span>
          <div class="tips">
            <el-tooltip class="item" content="结算当前筛选条件下的全部未结算答卷" placement="top-start">
              <img src="@/assets/img/tips_gray.png" width="14" />
            </el-tooltip>
          </div>
        </el-button>
        <el-button
          class="tips-btn"
          size="small"
          :disabled="forms.settleStatus != 0 || (forms.settleStatus == 0 && total == 0)"
          @click="showDialogBatch('all')"
          >全部调价<span style="font-size: 14px" v-if="forms.settleStatus == 0">({{ total }})</span>
          <div class="tips">
            <el-tooltip class="item" content="对当前筛选条件下的全部未结算答卷实时批量调价" placement="top-start">
              <img src="@/assets/img/tips_gray.png" width="14" />
            </el-tooltip>
          </div>
        </el-button>
        <el-button size="small" type="primary" @click="showDialogBatch('bach')">批量调价</el-button>
      </el-col>
    </el-row>

    <data-table
      :data="data"
      :columns="option.column"
      :page="page"
      :showPage="true"
      :index="true"
      :indexFixed="true"
      :loading="loading"
      :span-method="spanMethod"
      :selection="true"
      @select="select"
      @select-all="selectAll"
      @size-change="sizeChange"
      @pagination-current-change="currentChange"
      @selection-change="SelectionChange"
      ref="tableRef"
      :height="'calc(100vh - 504px)'"
    >
      <!-- 结算状态 -->
      <template #settleStatus="{ row }">
        <div style="text-align：center;">
          <div
            :class="{
              'no-settle': row.settleStatus == 0,
              settlling: row.settleStatus == 1,
              settled: row.settleStatus == 2,
              's-status': true
            }"
          >
            {{ settleStatusMap[row.settleStatus] }}
          </div>
        </div>
      </template>
      <!-- 代理or调查员 -->
      <template #executorName="{ row }">
        <!-- <el-tooltip :content="row.executorId.toString()" placement="top-start">
          <span>{{ row.executorName }}</span>
        </el-tooltip> -->
        <span>{{ row.executorName }}</span>
      </template>
      <!-- 调价说明 -->
      <template #adjustDescribe="{ row }">
        <div style="text-align: left" v-if="row.adjustYuanAmount">
          <p>调价人：{{ row.adjusterName }}，调整时间：{{ row.adjustTime }}，</p>
          <p>调整说明：{{ row.adjustDescribe }}</p>
        </div>
      </template>
      <!-- 空状态 -->
      <template slot="empty">
        <empty-prompt :isAllOrNet="true" />
      </template>
      <!-- 菜单 -->
      <template #opt="{ row }">
        <el-button @click="showDialog(row)" size="small" type="primary">调整单价</el-button>
      </template>
    </data-table>
    <div class="sum-line">
      <span
        >已勾选调查员未结算费用总和（元）：<span>{{ sheetAmountSum }}</span></span
      >
      <el-button @click="generateSettlementBill()" size="small">生成结算单</el-button>
      <!-- <span class="total-sum">答卷费用合计（元）：<span>{{totalYuanAmount}}</span></span> -->
    </div>
    <!-- 生成结算单 弹框 -->
    <el-dialog
      :title="dialogSettlementBillTitle"
      :visible.sync="dialogSettlementBillVisible"
      width="600px"
      :before-close="handleSettlementBillClose"
    >
      <el-row>
        <el-col :span="24" class="bach-line">
          <p style="text-indent: 2em">
            您已选中<span class="bach-blue">{{ visitorNum }}</span
            >位调查员，涉及 <span class="bach-red">{{ taskNum }}</span
            >个任务，共计{{ sheetNum }}份未结算答卷。将按调查员为您生成 <span class="bach-red">{{ visitorNum }}</span
            >张结算单，【确定】后请切换至”结算单“查询及后续处理。
          </p>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleSettlementBillClose">取 消</el-button>
        <el-button type="primary" @click="createSettlement()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 调价 弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <el-form
        :model="dialogForm"
        :rules="rules"
        ref="dialogForm"
        label-width="180px"
        class="demo-dialogForm"
        label-position="left"
      >
        <el-row>
          <el-col :span="24" class="bach-line" v-if="dialogType != 'bach' && dialogType != 'all'">
            <span>当前答卷单价（元）：</span>
            <!-- <span v-else>您已选中<span class="bach-blue">{{sheetNum}}</span>份答卷，原单价（元）：</span> -->
            <span :class="{ 'bach-red': dialogType == 'bach' }">{{ dialogUnitPrice }}</span>
          </el-col>
        </el-row>
        <el-form-item label="调整后答卷单价（元）：" prop="realAmount">
          <el-input v-model="dialogForm.realAmount" placeholder="请输入正数，最多支持两位小数"></el-input>
        </el-form-item>
        <el-form-item label="调价原因：" prop="adjustDescribe">
          <el-input v-model="dialogForm.adjustDescribe" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="editMoney()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { answerSettleHeadInfo } from '@/api/wenjuan/settlement'
import mixins from './visitor-sheet-list-mixins'
import { assignment } from '@/assets/js/utils'
import SettlementDetail from '@/views/survey/settlement/components/settlement-detail'
import SearchFilter from '@/components/search-filter/SearchFilter'
import DataTable from '@/components/base/DataTable'
import EmptyPrompt from '@/components/base/EmptyPrompt'

export default {
  mixins: [mixins],
  components: {
    SettlementDetail,
    SearchFilter,
    DataTable,
    EmptyPrompt
  },
  data() {
    return {
      total: 0,
      loading: false,
      type: 5, // 答题奖励
      settleStatusMap: {
        0: '有未结算',
        1: '无未结算'
      }
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/line-style.scss';
.tips {
  position: absolute;
  top: 9px;
  right: 1px;
  cursor: pointer;
}
.tips-btn {
  position: relative;
}
::v-deep.el-table th div {
  line-height: 23px;
  white-space: normal;
  padding-left: 0px;
  display: block;
}
.tips-p {
  position: absolute;
  top: -50px;
  right: -9px;
  cursor: pointer;
  margin: 0;
}
.tips-p2 {
  position: absolute;
  top: -50px;
  right: -17px;
  cursor: pointer;
  margin: 0;
}
.bach-red {
  color: red;
  font-size: 14px;
  font-weight: 600;
}
.bach-blue {
  color: blue;
  font-size: 14px;
  font-weight: 600;
}
.bach-line {
  margin-bottom: 25px;
  padding-left: 10px;
}
.sum-line {
  // position: absolute;
  // bottom: 2px;
  // left: 10px;
  .el-button {
    margin-left: 20px;
  }
  .total-sum {
    position: relative;
    left: 80px;
  }
}
.avue-crud ::v-deep.avue-crud__pagination {
  margin-top: 0px;
  margin-bottom: 0px;
}
.red-line {
  position: absolute;
  bottom: -22px;
  left: 70px;
}
::v-deep.el-drawer__body {
  overflow-y: scroll;
  background-color: #f5f5f5;
  .el-card.is-always-shadow {
    box-shadow: unset;
  }
  .el-card__body {
    background-color: #f5f5f5;
    padding: 8px;
  }
}
::v-deep.el-drawer__header {
  margin-bottom: 0px;
  padding: 10px 0 10px 20px;
  background-color: #fff;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  opacity: 0.85;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #111111;
  line-height: 16px;
}
.no-settle {
  color: #cccccc;
  background: #ffffff;
  border: 1px solid #cccccc;
}
.settlling {
  color: #ff9932;
  background: #fff6ec;
  border: 1px solid #ff9932;
}
.settled {
  color: #b2d799;
  background: #f0f9ea;
  border: 1px solid #b2d799;
}
.s-status {
  border-radius: 2px;
  width: 63px;
  display: inline-block;
  height: 26px;
}
::v-deep.el-table__row {
  background-color: #ffffff !important;
}
::v-deep.el-table__row--striped td {
  background-color: #f5f5f5 !important;
}
.avue-crud ::v-deep.el-table th {
  background-color: #f5f5f5;
}
.top-line {
  margin-bottom: 13px;
  .text1 {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
  }
  .text2 {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
  }
  .text3 {
    font-size: 16px;
    color: #227ffe;
    line-height: 22px;
    cursor: pointer;
  }
}
</style>
